/**
 * A request the server answered with a non-2xx status. The HTTP clients throw
 * it in place of a bare Error, with the same message, so callers can branch on
 * the status. A request that got no answer (network, timeout) stays an Error.
 */
export class HttpError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "HttpError";
    this.status = status;
  }
}

/**
 * The HTTP status of a rejected request, or null when it got no answer. Also
 * reads the raw AxiosError the clients pass through for a 4xx without an
 * error body.
 */
export function httpStatusOf(error: unknown): number | null {
  if (error instanceof HttpError) return error.status;
  if (typeof error !== "object" || error === null || !("response" in error)) return null;
  const { response } = error;
  if (typeof response !== "object" || response === null || !("status" in response)) return null;
  return typeof response.status === "number" ? response.status : null;
}
